import { createTheme } from '@mui/material/styles';

const commonTheme = {
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
          padding: '8px 24px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
};

export const lightTheme = createTheme({
  ...commonTheme,
  palette: {
    mode: 'light',
    primary: {
      main: '#0f4c7c', // Professional dark blue
      light: '#1976d2',
      dark: '#083d64',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f5f5f5', // Neutral light gray
      light: '#fafafa',
      dark: '#e0e0e0',
      contrastText: '#333333',
    },
    success: {
      main: '#00695c', // Professional teal
      light: '#26a69a',
      dark: '#004d40',
    },
    error: {
      main: '#c62828', // Muted red
      light: '#d32f2f',
      dark: '#8e0000',
    },
    warning: {
      main: '#ef6c00', // Professional orange
      light: '#ff9800',
      dark: '#bf360c',
    },
    background: {
      default: '#fafafa', // Very light gray background
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a1a', // Near black for better readability
      secondary: '#666666', // Medium gray for secondary text
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
});

export const darkTheme = createTheme({
  ...commonTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2', // Brighter blue for dark mode
      light: '#42a5f5',
      dark: '#0f4c7c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#424242', // Dark gray
      light: '#616161',
      dark: '#212121',
      contrastText: '#ffffff',
    },
    success: {
      main: '#26a69a', // Brighter teal for dark mode
      light: '#4db6ac',
      dark: '#00695c',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
      dark: '#c62828',
    },
    warning: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#ef6c00',
    },
    background: {
      default: '#0f1419', // Professional dark blue-gray
      paper: '#1a1f2e', // Slightly lighter for cards
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0bec5', // Light blue-gray for secondary text
    },
  },
});